export interface GuComment {
  author: string;
  badge: string;
  content: string;
  likes: number;
  time: string;
  replies: number;
}

export interface GuEvent {
  id: string;
  title: string;
  category: string;
  categoryLabel: string;
  summary: string;
  cover: string;
  heat: number;
  commentCount: number;
  publishedAt: string;
  tags: string[];
  content: string[];
  highlight: GuComment;
  comments: GuComment[];
  sentiment: { support: number; oppose: number; neutral: number };
  related: string[];
}

export const guEvents: GuEvent[] = [
  {
    id: "livestream-price-drama",
    title: "带货一姐直播喊价翻车，评论区齐刷「这价格我劝你别买」",
    category: "live",
    categoryLabel: "直播翻车",
    summary:
      "一场标榜「全年最低」的直播专场被网友扒出同款商品更低价，评论区从追问变成了集体刷屏，热评区风向一夜反转。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20editorial%20illustration%20of%20a%20live%20stream%20price%20tag%20icon%20breaking%20apart%2C%20warm%20cream%20background%2C%20tomato%20red%20and%20golden%20amber%20accents%2C%20subtle%20teal%2C%20bold%20magazine%20poster%20style%2C%20abstract%20geometric%20shapes%2C%20no%20text%2C%20no%20real%20people%2C%20harmonious%20composition%2C%20high%20detail&width=800&height=600&seq=gu-cover-01&orientation=landscape",
    heat: 986000,
    commentCount: 48213,
    publishedAt: "2026-09-08",
    tags: ["直播带货", "价格争议", "评论区沦陷"],
    content: [
      "事件的起点并不复杂：一场主打「全网最低价」的直播专场结束后，有网友把同款商品的比价截图发到了评论区。最初只是零星几条追问，几个小时后，热评区已经变成了统一的比价现场。",
      "从数据上看，评论区的情绪拐点出现在开播后第 40 分钟。此前主流评论是「蹲一个」「终于等到」，之后迅速切换成「这价格认真的吗」「链接点进去不是这个价」这类质疑。这种风向的反转速度，是本轮吃瓜里最值得记录的一幕。",
      "值得注意的是，评论区里并不全是批评。仍然有一部分粉丝在维护，强调「赠品和售后算进去其实不贵」，但这些声音很快就淹没在比价截图中，转化成了二次讨论的热度。",
      "截至统计时点，该事件相关评论已累积四万余条，其中「价格对比」类的讨论占比接近六成。对吃瓜群众来说，这场瓜真正的看点不在商品本身，而在于一个直播间如何用几十分钟把评论区从狂欢变成审判。",
    ],
    highlight: {
      author: "比价小能手",
      badge: "神评",
      content: "别人直播是砍价，他直播是砍我们的智商。建议以后的直播间直接挂一个比价工具，别让我们自己动手。",
      likes: 28742,
      time: "9月8日 21:14",
      replies: 1203,
    },
    comments: [
      {
        author: "深夜看瓜不睡觉",
        badge: "热评",
        content: "我截图了开播前和开播后的评论区，简直是两个平行世界，太精彩了。",
        likes: 15620,
        time: "9月8日 21:32",
        replies: 486,
      },
      {
        author: "理性吃瓜第一名",
        badge: "理性",
        content: "先别急着骂，赠品价值也没算进去。不过话说回来，主播承诺的「最低」确实没做到。",
        likes: 9843,
        time: "9月8日 22:05",
        replies: 512,
      },
      {
        author: "钱包已空",
        badge: "路人",
        content: "我本来是要下单的，刷到第三条评论默默退出了。谢谢评论区的各位，帮我省了三百块。",
        likes: 22107,
        time: "9月8日 22:41",
        replies: 733,
      },
      {
        author: "老观众了",
        badge: "老粉",
        content: "看了三年直播，第一次见热评区这么整齐。以前是刷口号，现在是刷截图，时代变了。",
        likes: 7412,
        time: "9月9日 00:12",
        replies: 208,
      },
    ],
    sentiment: { support: 18, oppose: 63, neutral: 19 },
    related: ["influencer-breakup", "brand-endorsement-doubt"],
  },
  {
    id: "influencer-breakup",
    title: "百万粉情侣博主官宣分手，评论区从祝福秒变「早就看出来了」",
    category: "love",
    categoryLabel: "情感大瓜",
    summary:
      "两人同步发布长文宣布和平分手，但评论区的时间线比正文还长，网友开始逐条复盘过往视频里的蛛丝马迹。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20editorial%20illustration%20of%20a%20broken%20heart%20split%20into%20two%20puzzle%20pieces%2C%20warm%20cream%20background%2C%20tomato%20red%20and%20golden%20amber%20accents%2C%20subtle%20teal%2C%20bold%20magazine%20poster%20style%2C%20abstract%20geometric%20shapes%2C%20no%20text%2C%20no%20real%20people%2C%20harmonious%20composition%2C%20high%20detail&width=800&height=600&seq=gu-cover-02&orientation=landscape",
    heat: 812000,
    commentCount: 39680,
    publishedAt: "2026-09-06",
    tags: ["情感博文", "分手复盘", "时间线考据"],
    content: [
      "两人几乎在同一分钟发布了分手长文，措辞克制、态度友好，标准的「和平分开」。但评论区并不打算配合这个温和的叙事。",
      "官宣发布后的两小时内，热度最高的不是祝福，而是一条整理时间线的长评论：从半年前的旅行视频里谁没出镜，到三个月前直播时的一句口误，网友把蛛丝马迹串成了一条完整的时间轴。",
      "这种「评论区考据」已经成为情感类吃瓜的固定节目。相比当事人的官方说法，路人更相信自己从内容细节里拼出的版本，而评论区恰好提供了这种集体推理的场所。",
      "最终这场瓜的走向很典型：当事人越平静，评论区越热闹。祝福与质疑在热评区并存，谁也说服不了谁，但热度实打实地涨了整整一天。",
    ],
    highlight: {
      author: "显微镜女孩",
      badge: "神评",
      content: "别人的分手声明八百字，评论区的复盘八万字。当事人只需要发一句再见，剩下的交给网友。",
      likes: 31408,
      time: "9月6日 20:03",
      replies: 1587,
    },
    comments: [
      {
        author: "考古学家本家",
        badge: "热评",
        content: "半年前那期视频我就觉得不对劲了，评论区当时还有人说我想多了，现在好了，排排坐。",
        likes: 18744,
        time: "9月6日 20:41",
        replies: 902,
      },
      {
        author: "只吃瓜不站队",
        badge: "理性",
        content: "和平分开就挺好，别把人家的私人感情当成推理游戏。不过时间线确实挺巧的。",
        likes: 6203,
        time: "9月6日 21:19",
        replies: 377,
      },
      {
        author: "祝福派代表",
        badge: "路人",
        content: "磕了两年，今天正式毕业。希望两个人都好好的，评论区别吵了。",
        likes: 13298,
        time: "9月7日 08:22",
        replies: 164,
      },
    ],
    sentiment: { support: 34, oppose: 41, neutral: 25 },
    related: ["livestream-price-drama", "comeback-pr-scandal"],
  },
  {
    id: "brand-endorsement-doubt",
    title: "口碑博主接争议代言，评论区出现「取关潮」还是「真香」？",
    category: "business",
    categoryLabel: "带货争议",
    summary:
      "以「只推自己用的」立人设的测评博主接下争议品牌代言，评论区迅速分成取关派和理解派，吵到热搜前排。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20editorial%20illustration%20of%20a%20handshake%20with%20a%20fading%20contract%20document%20and%20a%20thumbs%20down%20icon%2C%20warm%20cream%20background%2C%20tomato%20red%20and%20golden%20amber%20accents%2C%20subtle%20teal%2C%20bold%20magazine%20poster%20style%2C%20abstract%20geometric%20shapes%2C%20no%20text%2C%20no%20real%20people%2C%20high%20detail&width=800&height=600&seq=gu-cover-03&orientation=landscape",
    heat: 734000,
    commentCount: 31550,
    publishedAt: "2026-09-04",
    tags: ["人设崩塌", "取关潮", "代言争议"],
    content: [
      "这位博主的立身之本是一句简单的话：「只推我自己在用的」。正因为这句话，他的评论区长期是最干净的那一类，粉丝信任度在同类账号里排名靠前。",
      "代言消息公布的当天下午，评论区的画风就开始分裂。一边是整齐的「已取关」队列，认为这等于背叛了人设；另一边则认为「接代言很正常，只要产品没问题」。两派在热评区正面交锋。",
      "耐人寻味的是，这场争论的热度峰值出现在第二天，而不是官宣当天。原因是博主发了一条回应视频，但视频里没有正面回答问题，评论区的不满反而升级了。",
      "这类「人设型博主」的吃瓜看点，本质上是信任如何在一夜之间被消耗。评论区既是审判席，也是缓冲带，最终的结果往往取决于当事人回应的诚意。",
    ],
    highlight: {
      author: "曾经的老粉",
      badge: "神评",
      content: "我们不是不能接受你赚钱，我们是不能接受你一边赚钱一边说自己是你的粉丝。人设是你自己立的，别怪我们记得清楚。",
      likes: 25963,
      time: "9月4日 18:47",
      replies: 1120,
    },
    comments: [
      {
        author: "取关已完成",
        badge: "热评",
        content: "关注了五年，取关只用了五秒。不是因为代言，是因为回应里一句实话都没有。",
        likes: 17402,
        time: "9月4日 19:22",
        replies: 645,
      },
      {
        author: "佛系看客",
        badge: "理性",
        content: "接代言赚钱无可厚非，但「只推自己在用的」这句话以后就别说了，不然就是自己打脸。",
        likes: 11052,
        time: "9月4日 20:10",
        replies: 389,
      },
      {
        author: "产品才是重点",
        badge: "路人",
        content: "别吵了，先看看产品到底怎么样。如果好用我还是会买，如果不好用那这波就是纯纯的割韭菜。",
        likes: 8730,
        time: "9月5日 09:35",
        replies: 271,
      },
    ],
    sentiment: { support: 29, oppose: 52, neutral: 19 },
    related: ["livestream-price-drama", "industry-insider-bombshell"],
  },
  {
    id: "comeback-pr-scandal",
    title: "退网半年的网红突然复出，评论区第一条就把气氛搞僵了",
    category: "comeback",
    categoryLabel: "复出洗白",
    summary:
      "以「闭关调整」为由停更半年的博主宣布回归，首条视频播放量很高，但评论区的第一条高赞评论直接问起了当初的旧账。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20editorial%20illustration%20of%20a%20spotlight%20rising%20over%20an%20empty%20stage%20with%20a%20single%20microphone%2C%20warm%20cream%20background%2C%20tomato%20red%20and%20golden%20amber%20accents%2C%20subtle%20teal%2C%20bold%20magazine%20poster%20style%2C%20abstract%20geometric%20shapes%2C%20no%20text%2C%20no%20real%20people%2C%20high%20detail&width=800&height=600&seq=gu-cover-04&orientation=landscape",
    heat: 668000,
    commentCount: 27310,
    publishedAt: "2026-09-02",
    tags: ["复出", "旧账重提", "评论区翻车"],
    content: [
      "半年前，这位博主因为一场争议选择停更，只留下一句「需要时间调整」。半年后回归视频上线，制作水准没有下降，看得出是有备而来。",
      "但评论区显然没有打算配合「重新开始」的剧本。视频上线二十分钟内，第一条高赞评论出现了：「当初那件事，还是没有人解释过。」这条评论被顶到了最上面。",
      "支持者的逻辑是「人都会犯错，给个机会」；反对者的逻辑是「不是不能复出，是欠一句交代」。两种说法在评论区反复拉锯，形成了典型的「复出型」舆情结构。",
      "从吃瓜角度看，复出事件最有意思的地方在于：沉默半年并不能清空记忆，评论区往往比当事人更记得清楚当初发生了什么。",
    ],
    highlight: {
      author: "记性特别好",
      badge: "神评",
      content: "半年是挺长的，长到你可能忘了当初说过什么。但没关系，评论区帮你记着，一条都没删。",
      likes: 22381,
      time: "9月2日 17:58",
      replies: 934,
    },
    comments: [
      {
        author: "给个机会吧",
        badge: "热评",
        content: "人非圣贤，能回来好好做内容就行。揪着过去不放也没什么意义。",
        likes: 9144,
        time: "9月2日 18:30",
        replies: 712,
      },
      {
        author: "旧账必须说清",
        badge: "理性",
        content: "我们不是要你退网，是要你正面回应。消失半年不叫回应，叫冷处理。",
        likes: 14086,
        time: "9月2日 19:02",
        replies: 508,
      },
      {
        author: "纯路人围观",
        badge: "路人",
        content: "这条视频的评论区比视频本身好看多了，建议直接出个评论区纪录片。",
        likes: 7382,
        time: "9月3日 10:14",
        replies: 173,
      },
    ],
    sentiment: { support: 37, oppose: 45, neutral: 18 },
    related: ["influencer-breakup", "industry-insider-bombshell"],
  },
  {
    id: "industry-insider-bombshell",
    title: "前员工爆料行业套路，评论区集体「原来如此」，翻车现场升级",
    category: "industry",
    categoryLabel: "行业爆料",
    summary:
      "一则自称前员工的爆料帖把内容变现的内幕摊开来讲，评论区从围观变成了集体补充，越来越多人晒出自己的经历。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20editorial%20illustration%20of%20a%20leaked%20folder%20opening%20with%20geometric%20data%20fragments%20flying%20out%2C%20warm%20cream%20background%2C%20tomato%20red%20and%20golden%20amber%20accents%2C%20subtle%20teal%2C%20bold%20magazine%20poster%20style%2C%20abstract%20shapes%2C%20no%20text%2C%20no%20real%20people%2C%20high%20detail&width=800&height=600&seq=gu-cover-05&orientation=landscape",
    heat: 601000,
    commentCount: 24870,
    publishedAt: "2026-08-30",
    tags: ["行业内幕", "集体补充", "爆料帖"],
    content: [
      "一篇自称「前员工」的爆料帖在深夜发出，内容并不耸人听闻，讲的是内容行业里那些大家心知肚明、但很少摆上台面的操作流程。",
      "真正让这件事出圈的，是评论区。帖子发出后，越来越多自称同行的人开始在评论区补充细节，有人核对数据，有人补充操作方式，评论区变成了一本「行业说明书」。",
      "这种「集体补充型」吃瓜和单一爆料不同，它的可信度建立在多个独立来源的相互印证上。当三五个人说的细节能对上，围观的吃瓜群众自然会信。",
      "当然也有质疑的声音，认为部分补充内容缺乏证据。但无论如何，评论区在这场讨论里的角色，已经从旁观者变成了内容生产者。",
    ],
    highlight: {
      author: "前同行路过",
      badge: "神评",
      content: "帖子里写的只是冰山一角。评论区才是正文，建议作者把评论区整理成第二篇。",
      likes: 19644,
      time: "8月30日 23:41",
      replies: 806,
    },
    comments: [
      {
        author: "补充一条",
        badge: "热评",
        content: "我也做过类似的岗位，第 3 点完全属实，甚至实际比写的还夸张。",
        likes: 12937,
        time: "8月31日 00:15",
        replies: 442,
      },
      {
        author: "保持怀疑",
        badge: "理性",
        content: "有些说法还是要证据，不能因为三个人都这么说就当成定论。围观归围观，别替别人定罪。",
        likes: 6801,
        time: "8月31日 08:03",
        replies: 315,
      },
      {
        author: "看懂了",
        badge: "路人",
        content: "看完这个帖子我默默取关了好几个账号，原来我一直以为的真诚都是设计好的。",
        likes: 10258,
        time: "8月31日 12:47",
        replies: 228,
      },
    ],
    sentiment: { support: 44, oppose: 30, neutral: 26 },
    related: ["brand-endorsement-doubt", "live-argue-marathon"],
  },
  {
    id: "live-argue-marathon",
    title: "两位主播连麦互撕四小时，评论区忙到没空打字只发问号",
    category: "feud",
    categoryLabel: "互撕对决",
    summary:
      "一场本该十分钟结束的连麦变成了四小时拉锯战，评论区从站队变成刷问号，最后连围观者都开始劝架。",
    cover:
      "https://readdy.ai/api/search-image?query=Flat%20vector%20editorial%20illustration%20of%20two%20opposing%20speech%20bubbles%20colliding%20with%20spark%20shapes%2C%20warm%20cream%20background%2C%20tomato%20red%20and%20golden%20amber%20accents%2C%20subtle%20teal%2C%20bold%20magazine%20poster%20style%2C%20abstract%20geometric%20shapes%2C%20no%20text%2C%20no%20real%20people%2C%20high%20detail&width=800&height=600&seq=gu-cover-06&orientation=landscape",
    heat: 549000,
    commentCount: 22140,
    publishedAt: "2026-08-28",
    tags: ["连麦互撕", "站队", "问号刷屏"],
    content: [
      "事情的起因很小：两位主播在同一个话题上观点不同，其中一位提议连麦聊清楚。所有人都以为这会是十分钟的对话，结果它持续了四个小时。",
      "前一个小时，评论区还在认真站队，两边各自拉人；到了第二小时，评论内容开始变成「等等，他刚才说的是什么意思」；第三小时之后，热评区基本只剩下一排排的问号。",
      "这场吃瓜最特别的地方，是它几乎没有赢家。双方都没有说服对方，围观者也逐渐从兴奋转向疲惫，最后的评论风向变成了「你们先停下来喝口水」。",
      "当争论时长超过了一个阈值，评论区就会从战场变成剧场。人们不再关心谁对谁错，只关心这场戏什么时候结束。",
    ],
    highlight: {
      author: "只想说一句",
      badge: "神评",
      content: "看到第三个小时我怀疑自己是不是点错了直播。建议平台给连麦加个时长上限，救救评论区。",
      likes: 16921,
      time: "8月28日 23:02",
      replies: 588,
    },
    comments: [
      {
        author: "站左边",
        badge: "热评",
        content: "前面逻辑都在左边，问题是他后来情绪上来了就开始跑题，机会全浪费了。",
        likes: 8412,
        time: "8月28日 23:30",
        replies: 402,
      },
      {
        author: "谁也别说谁",
        badge: "理性",
        content: "四小时下来两个人说的其实是两件事，根本不在一个频道上，鸡同鸭讲能聊到天亮。",
        likes: 11074,
        time: "8月29日 00:08",
        replies: 356,
      },
      {
        author: "围观到困了",
        badge: "路人",
        content: "我是来看瓜的，结果看到凌晨两点，什么都没看懂，只收获了一堆问号。",
        likes: 9263,
        time: "8月29日 02:15",
        replies: 141,
      },
    ],
    sentiment: { support: 40, oppose: 42, neutral: 18 },
    related: ["brand-endorsement-doubt", "comeback-pr-scandal"],
  },
];

export const getEventById = (id: string): GuEvent | undefined =>
  guEvents.find((item) => item.id === id);